<template>
    <div class="promotion-rules-page">
        <section id="page-header">
            <div class="container">
                <div class="page-title-wrap">
                    <div class="page-title-inner">
                        <p class="blog-title"> {{ getLanguage['SMB']['PRS'] }} </p><br /><br />
                    </div>
                </div>
            </div>
        </section>


        <section id="page-content">
            <div class="container">
                <div class="row">
                    <div class="container col-6 py-2">
                        <p><strong>1. {{ getLanguage['PRS']['FDPT'] }}</strong></p>
                        <div class="content-text py-4">
                            A. {{ getLanguage['PRS']['ITP'] }} <span class="txt-win"><strong> {{ getLanguage['PRS']['WIN'] }}</strong></span> {{ getLanguage['PRS']['ATT'] }} <br />
                            <span class="txt-bonus"><strong>⇉</strong></span> {{ getLanguage['PRS']['THT'] }} <span class="txt-bonus"><strong>{{ getLanguage['PRS']['BONUS'] }}</strong></span> + {{ getLanguage['PRS']['WAW'] }} <strong>{{ getLanguage['PRS']['FORF'] }}</strong><br />
                            B. {{ getLanguage['PRS']['ITP'] }} <span class="txt-lose"><strong>{{ getLanguage['PRS']['LOSE'] }} </strong></span>[{{ getLanguage['PRS']['PAR'] }}] {{ getLanguage['PRS']['ATT'] }} <br />
                            <span class="txt-bonus"><strong>⇉</strong></span> {{ getLanguage['PRS']['THO'] }} <strong>{{ getLanguage['PRS']['FORF'] }}</strong>
                        </div>
                    </div>
                    <div class="container col-6 py-2">
                        <table class="CalculationTable py-4">
                            <tbody>
                                <tr>
                                    <td rowspan="0" class="verttext">{{ getLanguage['DM']['EX'] }}</td>
                                    <td></td>
                                    <td>{{ getLanguage['PRS']['STR'] }}</td>
                                    <td>{{ getLanguage['PRS']['END'] }}</td>
                                </tr>
                                <tr>

                                    <td>1A</td>
                                    <td>{{ getLanguage['PRS']['DEPO'] }}: 10,000<br>{{ getLanguage['BETRPT']['BNS'] }}:<span class="txt-bonus"><strong> 1,000</strong></span><br>T/O: x10 (110,000)<br><strong>{{ getLanguage['PM']['WBB'] }}: 11,000</strong></td>
                                    <td>{{ getLanguage['BAL']['B'] }}:<strong><span class="txt-win"> 15,000</span></strong><br>T/O: <span class="txt-lose"><strong>88,000</strong></span>/<strong>110,000</strong><br>{{ getLanguage['PRS']['APC'] }} -<br><strong>{{ getLanguage['PM']['WBB'] }}: 10,000</strong></td>
                                </tr>
                                <tr>

                                    <td>1B</td>
                                    <td>{{ getLanguage['PRS']['DEPO'] }}: 10,000<br>{{ getLanguage['BETRPT']['BNS'] }}:<span class="txt-bonus"><strong> 1,000</strong></span><br>T/O: x10 (110,000)<br><strong>{{ getLanguage['PM']['WBB'] }}: 11,000</strong></td>
                                    <td>{{ getLanguage['BAL']['B'] }}: <strong><span class="txt-lose"> 8,000</span></strong><br>T/O: <span class="txt-lose"><strong>88,000</strong></span>/<strong>110,000</strong><br>{{ getLanguage['PRS']['APC'] }} -<br><strong>{{ getLanguage['PM']['WBB'] }}: 4,000</strong></td>
                                </tr>
                            </tbody>
                        </table>



                    </div>
                    <div class="container col-6 py-2">
                        <p><strong>2. {{ getLanguage['PRS']['EDPT'] }}</strong></p>
                        <div class="content-text py-4">
                            A. {{ getLanguage['PRS']['ITP'] }} <span class="txt-win"><strong> {{ getLanguage['PRS']['WIN'] }}</strong></span> {{ getLanguage['PRS']['ATT'] }}
                            <br /><span class="txt-bonus"><strong>⇉</strong></span> {{ getLanguage['PRS']['THT'] }} <span class="txt-bonus"><strong>{{ getLanguage['PRS']['BONUS'] }}</strong></span> + {{ getLanguage['PRS']['WAW'] }} <strong>{{ getLanguage['PRS']['FORF'] }}</strong>
                            <br />B. {{ getLanguage['PRS']['ITP'] }} <span class="txt-lose"><strong>{{ getLanguage['PRS']['LOSE'] }}</strong></span> [{{ getLanguage['PRS']['PAR'] }}] {{ getLanguage['PRS']['ATT'] }} {{ getLanguage['PRS']['ARB'] }} > <span class="txt-bonus"><strong>{{ getLanguage['BETRPT']['BNS'] }}</strong></span> {{ getLanguage['PRS']['COL'] }}
                            <br /><span class="txt-bonus"><strong>⇉</strong></span> {{ getLanguage['PRS']['TRB'] }} - [{{ getLanguage['PRS']['MINU'] }}] <span class="txt-bonus"><strong>{{ getLanguage['PRS']['BONUS'] }}</strong></span> {{ getLanguage['PRS']['AWB'] }} <strong>{{ getLanguage['PRS']['FORF'] }}</strong>
                            <br />C. {{ getLanguage['PRS']['ITP'] }} <span class="txt-lose"><strong>{{ getLanguage['PRS']['LOSE'] }}</strong></span> [{{ getLanguage['PRS']['PAR'] }}] {{ getLanguage['PRS']['ATT'] }} {{ getLanguage['PRS']['ARB'] }} ≤ <span class="txt-bonus"><strong>{{ getLanguage['BETRPT']['BNS'] }}</strong></span> {{ getLanguage['PRS']['COL'] }}
                            <br /><span class="txt-bonus"><strong>⇉</strong></span> {{ getLanguage['PRS']['TNWB'] }} {{ getLanguage['PRS']['FORF'] }}
                        </div>
                    </div>
                    <div class="container col-6 py-2">
                        <table class="CalculationTable py-4">
                            <tbody>
                                <tr>
                                    <td rowspan="0" class="verttext">{{ getLanguage['DM']['EX'] }}</td>
                                    <td></td>
                                    <td>{{ getLanguage['PRS']['STR'] }}</td>
                                    <td>{{ getLanguage['PRS']['END'] }}</td>
                                </tr>
                                <tr>

                                    <td>2A</td>
                                    <td>{{ getLanguage['PRS']['DEPO'] }}: 10,000<br>{{ getLanguage['BETRPT']['BNS'] }}:<span class="txt-bonus"><strong> 1,000</strong></span><br>T/O: x10 (110,000)<br><strong>{{ getLanguage['PM']['WBB'] }}: 11,000</strong></td>
                                    <td>{{ getLanguage['BAL']['B'] }}:<strong><span class="txt-win"> 15,000</span></strong><br>T/O: <span class="txt-lose"><strong>88,000</strong></span>/<strong>110,000</strong><br>{{ getLanguage['PRS']['APC'] }} -<br><strong>{{ getLanguage['PM']['WBB'] }}: 10,000</strong></td>
                                </tr>
                                <tr>

                                    <td>2B</td>
                                    <td>{{ getLanguage['PRS']['DEPO'] }}: 10,000<br>{{ getLanguage['BETRPT']['BNS'] }}:<span class="txt-bonus"><strong> 1,000</strong></span><br>T/O: x10 (110,000)<br><strong>{{ getLanguage['PM']['WBB'] }}: 11,000</strong></td>
                                    <td>{{ getLanguage['BAL']['B'] }}: <strong><span class="txt-lose">8,000</span></strong><br>T/O: <span class="txt-lose"><strong>88,000</strong></span>/<strong>110,000</strong><br>{{ getLanguage['PRS']['APC'] }} -<br><strong>{{ getLanguage['PM']['WBB'] }}: 7,000</strong></td>
                                </tr>
                                <tr>
                                    <td>2C</td>
                                    <td>{{ getLanguage['PRS']['DEPO'] }}: 10,000<br>{{ getLanguage['BETRPT']['BNS'] }}: <span class="txt-bonus"><strong> 1,000</strong></span><br>T/O: x10 (110,000)<br><strong>{{ getLanguage['PM']['WBB'] }}: 11,000</strong></td>
                                    <td>{{ getLanguage['BAL']['B'] }}: <strong><span class="txt-lose">800</span></strong><br />T/O: <span class="txt-lose"><strong>88,000</strong></span>/<strong>110,000</strong><br />{{ getLanguage['PRS']['APC'] }} -<br />{{ getLanguage['BAL']['B'] }} < <span class="
                                                                                                                                                                                                                                                                                                     bonus"><strong>{{ getLanguage['BETRPT']['BNS'] }}</strong></span> <br /><strong>{{ getLanguage['PM']['WBB'] }}: 800</strong></td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                    <div class="container col-6 py-2">
                        <p><strong>3. {{ getLanguage['PRS']['EBFD'] }}</strong></p>
                        <div class="content-text py-4">
                            A. {{ getLanguage['PRS']['ITP'] }} <span class="txt-win"><strong> {{ getLanguage['PRS']['WIN'] }}</strong></span> {{ getLanguage['PRS']['ATT'] }} <br />
                            <span class="txt-bonus"><strong>⇉</strong></span> {{ getLanguage['PRS']['THEN'] }} {{ getLanguage['PRS']['WAW'] }} <strong>{{ getLanguage['PRS']['FORF'] }}</strong><br />
                            B. {{ getLanguage['PRS']['ITP'] }} <span class="txt-lose"><strong>{{ getLanguage['PRS']['LOSE'] }} </strong></span>[{{ getLanguage['PRS']['PAR'] }}] {{ getLanguage['PRS']['ATT'] }} <br />
                            <span class="txt-bonus"><strong>⇉</strong></span> {{ getLanguage['PRS']['THO'] }} <strong>{{ getLanguage['PRS']['FORF'] }}</strong>
                        </div>
                    </div>
                    <div class="container col-6 py-2">
                        <table class="CalculationTable py-4">
                            <tbody>
                                <tr>
                                    <td rowspan="0" class="verttext">{{ getLanguage['DM']['EX'] }}</td>
                                    <td></td>
                                    <td>{{ getLanguage['PRS']['STR'] }}</td>
                                    <td>{{ getLanguage['PRS']['END'] }}</td>
                                </tr>
                                <tr>

                                    <td>3A</td>
                                    <td>{{ getLanguage['PRS']['DEPO'] }}: 10,000<br>{{ getLanguage['BETRPT']['BNS'] }}:<span class="txt-bonus"><strong> 1,000</strong></span><br>T/O: x10 (110,000)<br><strong>{{ getLanguage['PM']['WBB'] }}: 10,000</strong></td>
                                    <td>{{ getLanguage['BAL']['B'] }}:<strong><span class="txt-win"> 15,000</span></strong><br>T/O: <span class="txt-lose"><strong>88,000</strong></span>/<strong>110,000</strong><br>{{ getLanguage['PRS']['APC'] }} -<br><strong>{{ getLanguage['PM']['WBB'] }}: 10,000</strong></td>
                                </tr>
                                <tr>

                                    <td>3B</td>
                                    <td>{{ getLanguage['PRS']['DEPO'] }}: 10,000<br>{{ getLanguage['BETRPT']['BNS'] }}:<span class="txt-bonus"><strong> 1,000</strong></span><br>T/O: x10 (110,000)<br><strong>{{ getLanguage['PM']['WBB'] }}: 10,000</strong></td>
                                    <td>{{ getLanguage['BAL']['B'] }}: <strong><span class="txt-lose">8,000</span></strong><br>T/O: <span class="txt-lose"><strong>88,000</strong></span>/<strong>110,000</strong><br>{{ getLanguage['PRS']['APC'] }} -<br><strong>{{ getLanguage['PM']['WBB'] }}: 4,000</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="container col-6 py-2">
                        <p><strong>4. {{ getLanguage['PRS']['EBED'] }}</strong></p>
                        <div class="content-text py-4">
                            A. {{ getLanguage['PRS']['ITP'] }} <span class="txt-win"><strong> {{ getLanguage['PRS']['WIN'] }}</strong></span> {{ getLanguage['PRS']['ATT'] }}
                            <br /><span class="txt-bonus"><strong>⇉</strong></span> {{ getLanguage['PRS']['THEN'] }} {{ getLanguage['PRS']['WAW'] }} <strong>{{ getLanguage['PRS']['FORF'] }}</strong>
                            <br />B. {{ getLanguage['PRS']['ITP'] }} <span class="txt-lose"><strong>{{ getLanguage['PRS']['LOSE'] }} </strong></span>[{{ getLanguage['PRS']['PAR'] }}] {{ getLanguage['PRS']['ATT'] }} <br />
                            <span class="txt-bonus"><strong>⇉</strong></span> {{ getLanguage['PRS']['THO'] }} <strong>{{ getLanguage['PRS']['FORF'] }}</strong>

                        </div>
                    </div>
                    <div class="container col-6 py-2">
                        <table class="CalculationTable py-4">
                            <tbody>
                                <tr>
                                    <td rowspan="0" class="verttext">{{ getLanguage['DM']['EX'] }}</td>
                                    <td></td>
                                    <td>{{ getLanguage['PRS']['STR'] }}</td>
                                    <td>{{ getLanguage['PRS']['END'] }}</td>
                                </tr>
                                <tr>

                                    <td>4A</td>
                                    <td>{{ getLanguage['PRS']['DEPO'] }}: 10,000<br>{{ getLanguage['BETRPT']['BNS'] }}:<span class="txt-bonus"><strong> 1,000</strong></span><br>T/O: x10 (110,000)<br><strong>{{ getLanguage['PM']['WBB'] }}: 10,000</strong></td>
                                    <td>{{ getLanguage['BAL']['B'] }}:<strong><span class="txt-win"> 15,000</span></strong><br>T/O: <strong><span class="txt-lose">88,000</span></strong>/<strong>110,000</strong><br>{{ getLanguage['PRS']['APC'] }} -<br><strong>{{ getLanguage['PM']['WBB'] }}: 10,000</strong></td>
                                </tr>
                                <tr>

                                    <td>4B</td>
                                    <td>{{ getLanguage['PRS']['DEPO'] }}: 10,000<br>{{ getLanguage['BETRPT']['BNS'] }}:<span class="txt-bonus"><strong> 1,000</strong></span><br>T/O: x10 (110,000)<br><strong>{{ getLanguage['PM']['WBB'] }}: 10,000</strong></td>
                                    <td>{{ getLanguage['BAL']['B'] }}: <strong><span class="txt-lose">8,000</span></strong><br>T/O: <strong><span class="txt-lose">88,000</span></strong>/<strong>110,000</strong><br>{{ getLanguage['PRS']['APC'] }} -<br><strong>{{ getLanguage['PM']['WBB'] }}: 4,000</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    </div>

</template>

<script>        
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'    
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'    
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import Vue from 'vue'    

    Vue.use(require('vue-moment'));

    export default {
        mixins: [genericHelper],
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess']),
        },
        created() {
            this.$parent.showSubMenu = 'P';
            this.$parent.showActiveMenu = 'P.PRS';

            if (this.$route.query.simplifymenu == 1) {
                this.$parent.showSubMenu = 'PRS';
                this.$parent.showActiveMenu = '';
            }
        }  
    }
</script>

<style scoped>

    .container {
        max-width: 1480px;
    }

    .promotion-rules-page #page-content .CalculationTable {
        width: 100%;
    }

        .promotion-rules-page #page-content .CalculationTable td {
            border-width: 2px;
            border-style: solid;
            padding: 3px;
        }

    .promotion-rules-page table .verttext {
        writing-mode: vertical-rl;
        text-orientation: upright;
        text-align: center;
    }

    .promotion-rules-page table .verttext {
        writing-mode: vertical-rl;
        text-orientation: upright;
        text-align: center;
    }

    .promotion-rules-page .txt-win {
        color: green;
    }

    .promotion-rules-page .txt-lose {
        color: red;
    }

    .promotion-rules-page .txt-bonus {
        color: #2ca1cb;
    }

    .promotion-rules-page .CalculationTable tr td:first-child {
        text-align: center;
    }

    .promotion-rules-page .content-text {
        font-size: 0.75rem;
    }      

    .promotion-rules-page .blog-title {
        font-size: 25px;
        text-decoration: underline;
        font-weight: bold;
        margin: 5px auto;
    }   

    .promotion-rules-page #page-content p {
        font-weight: 500;
        font-size: 0.9rem;
    }

    @media (max-width:426px) {
        .promotion-rules-page .container .col-6 {
            flex: none;
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Promotion/PromotionRules.vue